<template>
  <div>
    <div class="row">
      <div class="col-12">
        <span>En cola: {{ listGroupedLength }}</span>
      </div>

      <template v-for="(l, i) in listGrouped">
        <template v-if="l.length == 1">
          <CardProductSale
            :key="l[0].product_sale_id"
            :productSale="l[0]"
            @maked="removeFromListGrouped(i)"
          ></CardProductSale>
        </template>
        <template v-else>
          <CardGroup
            :key="i"
            :saleGroup="l"
            @maked="removeFromListGrouped(i)"
          ></CardGroup>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import { DinnerService } from "../DinnerService.js";
import CardProductSale from "./CardProductSale.vue";
import CardGroup from "./CardGroup.vue";
import _ from "lodash";

const removeItemFromQueue = (itemPosition, list) => {
  return () => {
    list.splice(itemPosition, 1);
  };
};

export default {
  components: {
    CardProductSale,
    CardGroup
  },

  // directives
  // filters

  props: {
    // maked: { default: 0 }
    list: {
      default: () => []
    }
  },

  data: () => ({
    listGrouped: {}
  }),

  computed: {
    listGroupedLength() {
      return Object.keys(this.listGrouped).length;
    }
    // listGrouped() {
    //   return _.groupBy(this.list, 'sale_id')
    // }
  },

  watch: {
    list(to) {
      this.listGrouped = _.groupBy(to, "sale_id");
    }
  },

  mounted() {
    //
  },

  methods: {
    removeFromListGrouped(position) {
      let listLess = JSON.parse(JSON.stringify(this.listGrouped));
      delete listLess[position];
      this.listGrouped = listLess;
    },
    make(itemPosition, item) {
      DinnerService.savePreparedProduct({
        product_sale_id: item.product_sale_id
      })
        .then(removeItemFromQueue(itemPosition, this.list))
        .catch((error) => {
          window.alert(error.response.data.message);
          removeItemFromQueue();
        });
    },
    undo(itemPosition, item) {
      DinnerService.savePreparedProduct({
        product_sale_id: item.product_sale_id,
        undo: 1
      }).then(removeItemFromQueue(itemPosition, this.list));
      // .catch(error => {
      //   window.alert(error.response.data.message);
      //   removeItemFromQueue();
      // });
    }
  }
};
</script>

<style scoped></style>
